import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { UserBrief } from '../../types/users'
import UserRow from './UserRow'
import UserRowSkeleton from './UserRow.skeleton'
import useStyles from './styles/UsersTable.styles'

interface UsersTableProps {
  userData: UserBrief[]
  loading: boolean
  refetch: () => void
}
const UsersTable: React.FC<UsersTableProps> = ({
  userData,
  loading,
  refetch
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Email')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Role')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Entity Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Status')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              refetch()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((_, index) => <UserRowSkeleton key={index} />)
        : userData.map((item) => <UserRow key={item.ID} data={item} />)}
    </div>
  )
}

export default UsersTable
